import { type BaseCardProps, BaseCard } from "@/components/fragments/card/base-card";
import { VStack } from "@chakra-ui/react";
import { type FC, type ReactNode } from "react";
import { Typography } from "@/components/essentials/typography";
import { Button, type ButtonProps } from "@/components/essentials/button";
import { confirmCardOkButtonTestId, confirmCardCancelButtonTestId } from "./const";

export interface ConfirmCardProps extends Omit<BaseCardProps, "children"> {
  headerImage?: ReactNode;
  headerMessage?: string;
  message?: string | ReactNode;
  okButtonLabel: string;
  cancelButtonLabel: string;
  okButtonProps?: Omit<ButtonProps, "children">;
  cancelButtonProps?: Omit<ButtonProps, "children">;
}

export const ConfirmCard: FC<ConfirmCardProps> = ({
  headerImage,
  headerMessage,
  message,
  cancelButtonLabel,
  okButtonLabel,
  okButtonProps,
  cancelButtonProps,
  ...rest
}) => {
  return (
    <BaseCard {...rest}>
      <VStack justifyContent="center" alignItems="center">
        {headerImage}
        <Typography variant="display6">{headerMessage}</Typography>
        <Typography textAlign="center" variant="text4" color="gray.dark" whiteSpace="pre-wrap">
          {message}
        </Typography>
        <VStack w="100%">
          <Button data-testid={confirmCardOkButtonTestId} styleVariant="secondary" w="100%" {...okButtonProps}>
            {okButtonLabel}
          </Button>
          <Button data-testid={confirmCardCancelButtonTestId} styleVariant="mono" w="100%" {...cancelButtonProps}>
            {cancelButtonLabel}
          </Button>
        </VStack>
      </VStack>
    </BaseCard>
  );
};
